document.addEventListener('DOMContentLoaded', () => {
  const menuItems = document.querySelectorAll('.wbmenuinner .header__menu-item');
  const allSubmenus = document.querySelectorAll('.list-menu--disclosure .container.submenu .wbmgproduct.sub');

  // Funzione per mostrare un submenu
  function showSubmenu(submenu) {
    submenu.style.display = "block";
  }

  // Funzione per nascondere un submenu
  function hideSubmenu(submenu) {
    submenu.style.display = "none";
  }

  // Loop per ogni voce di menu
  menuItems.forEach(item => {
    const collectionId = item.id;

    if (collectionId) {
      const submenuSelector = `.list-menu--disclosure .container.submenu #submenu-${collectionId}`;
      const submenu = document.querySelector(submenuSelector);

      if (submenu) {
        // Mostra il submenu quando si passa sopra la voce di menu
        item.addEventListener('mouseenter', () => {
          // Nascondi tutti gli altri submenus
          allSubmenus.forEach(sub => {
            if (sub !== submenu) hideSubmenu(sub);
          });

          showSubmenu(submenu);
        });

        // Evita di nascondere il submenu quando il mouse entra nel submenu stesso
        submenu.addEventListener('mouseenter', () => {
          showSubmenu(submenu);
        });

        // Nascondi il submenu quando il mouse esce sia dalla voce di menu che dal submenu
        item.addEventListener('mouseleave', () => {
          setTimeout(() => {
            if (!submenu.matches(':hover') && !item.matches(':hover')) {
              hideSubmenu(submenu);
            }
          }, 100); // Timeout per prevenire glitch durante il movimento del mouse
        });

        submenu.addEventListener('mouseleave', () => {
          setTimeout(() => {
            if (!submenu.matches(':hover') && !item.matches(':hover')) {
              hideSubmenu(submenu);
            }
          }, 100);
        });
      }
    }
  });
});
